import React, { useState, useEffect, useRef } from 'react';
import ConnectPop_logo from '../assets/images/Dashboard/ConnectPop_logo.svg';
import mer_dai_min_logo from '../assets/images/Dashboard/mer_dai_min_logo.svg';
import pangolin from '../assets/images/HomePage/pangolin.png';
import mer_dai_bottem_arrow from '../assets/images/Dashboard/mer_dai_bottem_arrow.svg';
import mercurycoin from '../assets/images/Dashboard/MeCoin.png';
import animeswap from '../assets/images/Dashboard/animeswap.png';
import aux from '../assets/images/Dashboard/liquidity.jpg';
import avaxLogo from '../assets/images/HomePage/avaxlogo.svg';
import box_Swap_icon from '../assets/images/Dashboard/box_Swap_icon.svg';

import { WebOffBotton } from '../component/common/WebOffBotton';
import { WebBotton } from '../component/common/WebBotton';
import MainPoolBox from '../DashboardComponent/Common/MainPoolBox';
import { MainPoolBoxData } from '../AllData/MainPoolBoxData';
import  MainPoolBox11  from '../DashboardComponent/Common/MainPoolBox11';
import  MainPoolBox2  from '../DashboardComponent/Common/MainPoolBox2';
import PageFilter from '../DashboardComponent/Common/PageFilter';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { assetbalance, mebalance } from '../config';
import Sidebar_menu_btn from '../assets/images/Dashboard/Sidebar_menu_btn.svg';
import { Badge, Button, Dropdown } from 'react-bootstrap';
import { ethers } from 'ethers';
import { BLACKTokenABI, BLACKTokenAddress } from '../abi/abi';

const PoolPage = () => {

    const [clicked, setClicked] = useState(false);
    const contentEl = useRef();

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [usdcbalance, setusdcbalance] = useState("");
    const [mesupply, setmesupply] = useState("");
    const[liquiidtyvalue,setliquiidtyvalue] = useState("");
    const[circulating,setcirculating] = useState("");
    const handleToggle = () => {
        setClicked((prev) => !prev);
    };

    useEffect(() => {
        asset()
    }, [])

    const asset = async() =>{
      const url = "https://avalanche-fuji.infura.io/v3/886e9a53b5da4f6286230678f7591bde";
            const provider = new ethers.providers.JsonRpcProvider(url);
            const JOKERContract = new ethers.Contract(BLACKTokenAddress, BLACKTokenABI, provider);
            let Jokerbalancecontract = ethers.utils.formatUnits(await JOKERContract.totalSupply(),0);
            let Jokerburnedcontract = ethers.utils.formatUnits(await JOKERContract.totalBurn(),0);
            let circulatingSupply = parseFloat(Jokerbalancecontract) - parseFloat(Jokerburnedcontract);
            setmesupply(circulatingSupply);
    }
    // const asset = async () => {
    //     let b = await assetbalance("0x954586b2e53518def690ae4b05e6ddaf538ff2eea1f855af7204b78212518df7","ME")
    //     console.log("usdcbalance",b)
    //     setusdcbalance(b)
    //     let k = await mebalance();
    //     console.log("value",k)
    //     setmesupply(k);
    // }

    useEffect(() => {fetchvalues3()},[])
    const fetchvalues3 = async()=>{
 //const assetbalance = async (address,token) => {
  try{
      let k =await fetch(`https://fullnode.testnet.aptoslabs.com/v1/accounts/0x796900ebe1a1a54ff9e932f19c548f5c1af5c6e7d34965857ac2f7b1d1ab2cbf/resource/0x1::coin::CoinInfo<0x796900ebe1a1a54ff9e932f19c548f5c1af5c6e7d34965857ac2f7b1d1ab2cbf::LPCoinV1::LPCoin<0x954586b2e53518def690ae4b05e6ddaf538ff2eea1f855af7204b78212518df7::TestCoins::USDC, 0x954586b2e53518def690ae4b05e6ddaf538ff2eea1f855af7204b78212518df7::TestCoins::MERCURY>>`)
      let a = await k.json()
      // console.log("demo",a)
      // console.log("dem",a.data.supply.vec[0].integer.vec[0].value)
      setliquiidtyvalue(a.data.supply.vec[0].integer.vec[0].value)
      // console.log("dem",a.data.coin_y_reserve.value)
      // console.log("dem",a.data.k_last)
      // setf3(a)
      // console.log("dem",a)
      
  } 
  catch(error){
      return -1
      
  }
  try{
    let k =await fetch(`https://fullnode.testnet.aptoslabs.com/v1/accounts/0xfc4161677bd8d6f73df53bd2d33d1bba388fd6612c0adf74073ccf08b35cfca3/resource/0x1::coin::CoinInfo<0xfc4161677bd8d6f73df53bd2d33d1bba388fd6612c0adf74073ccf08b35cfca3::staking::LP<0xcdeb42ad8c811615c25891963c1df21e84be300e27ac9ec9deafe77ddf7ef291::TestCoins::USDT>>`)
    let a = await k.json()
    // console.log("demo",a)
    // console.log("dem",a.data.supply.vec[0].integer.vec[0].value)
    setcirculating(a.data.supply.vec[0].integer.vec[0].value)
    // console.log("dem",a.data.coin_y_reserve.value)
    // console.log("dem",a.data.k_last)
    // setf3(a)
    // console.log("dem",a)
    
} 
catch(error){
    return -1
    
}
 
}
    return (
        <>
            <div className='Dashboard_main_wrapper'>
                <div className='Pool_Page_main'>
                    <PageFilter />
                    <div className='box_main_border'>
                        <div className='trade_now_block'>
                            <div className='trade_now_row'>
                                <div className='Market_Cap_row'>
                                <div className='center_logo_row'>
                                    <img src={mercurycoin} width = "40" height="40" alt="ConnectPop_logo" />
                                    <p>ME</p>
                                    {/* <span>-2.68%</span> */}
                                </div>
                                <span className='Market_Cap_center_span'></span>
                                    <div className='Market_Cap_text'>
                                        <p className='Market_text_p'>Circulating Supply</p>
                                        <h5 className='mer_text_h6'>{mesupply?parseFloat(mesupply/1e9).toFixed(3):"0.0"} <span>ME</span></h5>
                                    </div>
                                    {/* <span className='Market_Cap_center_span'></span> */}
                                    {/* <div className='Market_Cap_text'>
                                        <p className='Market_text_p'>Total Deposit</p>
                                        <h5 className='mer_text_h5'>{usdcbalance?parseFloat(Math.abs(usdcbalance)).toFixed(3):"0.0"} </h5>
                                    </div> */}
                                </div>
                                <div className='center_logo_row'>
                                    {/* <img src={mercurycoin} width = "40" height="40" alt="ConnectPop_logo" />
                                    <p>ME</p> */}
                                    {/* <span>-2.68%</span> */}
                                    
                                </div>
                                <div className='trade_btn_row'>
                                    {/* <WebOffBotton WebOffBotton="Bridge" link="#0" /> */}
                                    <WebBotton WebBotton="Trade Now" link="#0" click={()=>handleOpen()}/>
                                </div>
                            </div>
                            <div className='mer_dai'>
                                <div className='mer_dai_row'>
                                    <span></span>
                                    <div className='mer_dai_item_row' onClick={handleToggle}>
                                        <div className='mer_dai_icons'>
                                            <img src={mercurycoin}width="40" height={"40"} alt="ConnectPop_logo" />
                                            <img src={avaxLogo} width="40" height={"40"} alt="mer_dai_icon" />
                                        </div>
                                        <div className='mer_dai_item_text'>
                                            <p>ME-AVAX</p>
                                            {clicked ? <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10 0.5C8.02219 0.5 6.08879 1.08649 4.4443 2.1853C2.79981 3.28412 1.51809 4.8459 0.761209 6.67317C0.00433284 8.50043 -0.193701 10.5111 0.192152 12.4509C0.578004 14.3907 1.53041 16.1725 2.92894 17.5711C4.32746 18.9696 6.10929 19.922 8.0491 20.3079C9.98891 20.6937 11.9996 20.4957 13.8268 19.7388C15.6541 18.9819 17.2159 17.7002 18.3147 16.0557C19.4135 14.4112 20 12.4778 20 10.5C20 9.18678 19.7413 7.88642 19.2388 6.67317C18.7363 5.45991 17.9997 4.35752 17.0711 3.42893C16.1425 2.50035 15.0401 1.76375 13.8268 1.2612C12.6136 0.758658 11.3132 0.5 10 0.5V0.5ZM10 18.5C8.41775 18.5 6.87104 18.0308 5.55544 17.1518C4.23985 16.2727 3.21447 15.0233 2.60897 13.5615C2.00347 12.0997 1.84504 10.4911 2.15372 8.93928C2.4624 7.38743 3.22433 5.96197 4.34315 4.84315C5.46197 3.72433 6.88743 2.9624 8.43928 2.65372C9.99113 2.34504 11.5997 2.50346 13.0615 3.10896C14.5233 3.71447 15.7727 4.73984 16.6518 6.05544C17.5308 7.37103 18 8.91775 18 10.5C18 12.6217 17.1572 14.6566 15.6569 16.1569C14.1566 17.6571 12.1217 18.5 10 18.5V18.5Z" fill="#29ABE2" />
                                                <path d="M12.7099 7.78994C12.617 7.69621 12.5064 7.62182 12.3845 7.57105C12.2627 7.52028 12.132 7.49414 11.9999 7.49414C11.8679 7.49414 11.7372 7.52028 11.6154 7.57105C11.4935 7.62182 11.3829 7.69621 11.2899 7.78994L9.99994 9.08994L8.70994 7.78994C8.52164 7.60164 8.26624 7.49585 7.99994 7.49585C7.73364 7.49585 7.47824 7.60164 7.28994 7.78994C7.10164 7.97824 6.99585 8.23364 6.99585 8.49994C6.99585 8.76624 7.10164 9.02164 7.28994 9.20994L8.58994 10.4999L7.28994 11.7899C7.19621 11.8829 7.12182 11.9935 7.07105 12.1154C7.02028 12.2372 6.99414 12.3679 6.99414 12.4999C6.99414 12.632 7.02028 12.7627 7.07105 12.8845C7.12182 13.0064 7.19621 13.117 7.28994 13.2099C7.3829 13.3037 7.4935 13.3781 7.61536 13.4288C7.73722 13.4796 7.86793 13.5057 7.99994 13.5057C8.13195 13.5057 8.26266 13.4796 8.38452 13.4288C8.50638 13.3781 8.61698 13.3037 8.70994 13.2099L9.99994 11.9099L11.2899 13.2099C11.3829 13.3037 11.4935 13.3781 11.6154 13.4288C11.7372 13.4796 11.8679 13.5057 11.9999 13.5057C12.132 13.5057 12.2627 13.4796 12.3845 13.4288C12.5064 13.3781 12.617 13.3037 12.7099 13.2099C12.8037 13.117 12.8781 13.0064 12.9288 12.8845C12.9796 12.7627 13.0057 12.632 13.0057 12.4999C13.0057 12.3679 12.9796 12.2372 12.9288 12.1154C12.8781 11.9935 12.8037 11.8829 12.7099 11.7899L11.4099 10.4999L12.7099 9.20994C12.8037 9.11698 12.8781 9.00638 12.9288 8.88452C12.9796 8.76266 13.0057 8.63195 13.0057 8.49994C13.0057 8.36793 12.9796 8.23722 12.9288 8.11536C12.8781 7.9935 12.8037 7.8829 12.7099 7.78994V7.78994Z" fill="#29ABE2" />
                                            </svg> : <img src={mer_dai_bottem_arrow} alt="mer_dai_bottem_arrow" />
                                            }
                                        </div>
                                    </div>
                                    <span></span>
                                </div>
                                <div className='mer_dai_drop' ref={contentEl} style={clicked ? { height: contentEl.current.scrollHeight } : { height: "0px" }}>
                                    {/* <div className='mer_dai_drop_row'>
                                        <div className='mer_dai_drop_text'>
                                           <li> <img src={aux} width="40" height={"40"}alt="mer_dai_drop_item_logo" /> </li>
                                            <div className='mer_text'>
                                                <h5 className='mer_text_h5'>Liquidswap</h5>
                                                <p className='Market_text_p'></p>
                                                <p className='Market_text_p'></p>
                                                <Badge>  UPCOMING </Badge> 
                                            </div>
                                            <div className='hero_btn'>
                                            <a className='hero_btn' href='https://testnet.liquidswap.com/#/add-liquidity?from=0x954586b2e53518def690ae4b05e6ddaf538ff2eea1f855af7204b78212518df7::TestCoins::MERCURY&to=0x954586b2e53518def690ae4b05e6ddaf538ff2eea1f855af7204b78212518df7::TestCoins::USDC' target="_blank" rel="noreferrer" >UPCOMINGS                                            
                                            </a>
                                            </div>
                                            <WebOffBotton WebOffBotton="Upcoming" link="#0"  />
                                          
                                            
                                        </div>
                                        <div className='mer_dai_drop_text'>
                                            <img src={pangolin} width="40" height={"40"} alt="mer_dai_drop_item_logo" />
                                            <div className='mer_text'>
                                                <h5 className='mer_text_h5'>Animeswap</h5>
                                                <p className='Market_text_p'>Liquidity: {liquiidtyvalue?parseFloat(liquiidtyvalue/100000000).toFixed(2):"0.0"}</p>
                                                <p className='Market_text_p'>APY: 111.33%</p>
                                            </div>
                                            <div className='hero_btn'>
                                            <a className='hero_btn' href="https://app.pangolin.exchange/#/pool/standard" target="_blank" rel="noreferrer" >Farm
                                            
                                            </a>
                                            </div>
                                            <WebBotton WebBotton="Farm" href="https://staging.animeswap.org/#/swap?chain=aptos_testnet"  img={View_on_Explorer_icon} />
                                        </div>
                                    </div> */}
                                    <div className='mer_dai_drop_row'></div>
                                     <div className='swap_tokens_main'>
                        <div className='box_main_border'>
                            <div className='trade_now_block'>
                                <h4>Add Liquidity</h4>
                                <div className='trade_now_max'>
                                    <div className='trade_now_row_row'>
                                        <div className='from_text_block'>
                                            {/* <span className='Market_text_p'>ME</span> */}
                                            <input type="text" 
                                            // placeholder={token === null ? From_Value.toFixed(2) : "0.00"} 
                                            // onChange={event => changeinput(event.target.value)} value={amount?(amount):''}
                                            />
                                        </div>
                                        <div className='max_btn_main'>
                                            <div className='max_btn'>
                                                <a href="#0" 
                                                // onClick={()=>maxval()}
                                                >ME</a>
                                              
                                            </div>
                                            <div className='max_icon_text' 
                                            // onClick={handleOpen}
                                            >
                                              <img src={mercurycoin} alt="logo" />
                                                {/* <img src={TokenData[1].imglogo} alt="logo" />
                                                <span>{TokenData[1].text}</span> */}
                                                {/* {token === null ? "" : <img src={Tovalue.imglogo} alt={Tovalue.imglogo} />} */}
                                                {/* <span>{token === null ? "Select a Token" : Tovalue.text}</span> */}
                                                {/* <img src={mer_dai_bottem_arrow} alt="logo" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='box_Swap_icon'
                                    //  onClick={()=>changewallet()}
                                     >
                                        <img src={box_Swap_icon} alt="" />
                                    </div>
                                    <div className='trade_now_row_row'>
                                        <div className='from_text_block'>
                                            {/* <span className='Market_text_p'>AVAX</span> */}
                                             <input type="text" 
                                            //  placeholder={token2 === null ? From_Value.toFixed(2) :"0.00"} value={amount2?formatter(amount2):'0.00'} 
                                             />
                                        </div>
                                        <div className='max_btn_main'>
                                            <div className='max_btn'>
                                                <a href="#0">AVAX</a>
                                            </div>
                                            <div className='max_icon_text' 
                                            // onClick={handleOpen2}
                                            >
                                                <img src={avaxLogo}  alt="logo" />
                                                {/* {token2 === null ? "" : <img src={Tovalue2.imglogo} alt={Tovalue2.imglogo} />} */}
                                                {/* <span>{token2 === null ? "Select a Token" : Tovalue2.text}</span> */}
                                                {/* <img src={mer_dai_bottem_arrow} alt="logo" /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='after_fee_show_main'>

                                        {/* {token2 === null ? null : (
                                            <>
                                                <ul className='after_fee_show_ul'>
                                                    <li>
                                                        <span className='Market_text_p'>Coverage Ratio: 
                                                        <span className='cm_ques_info'>
                                <img src={akar_icons_question} alt="akar_icons_question" />
                                <span className='cm_ques_box'>
                                The coverage Ratio(CR) is the asset-to-liability ratio of the pool.  Refer to our documentation for more details.
                                </span>
                              </span></span>
                                                        <p className='Market_text_p'>{liability?formatter(Math.abs(poolbalance/liability)):"0.0"} </p>
                                                    </li>
                                                    <li>
                                                        <span className='Market_text_p'>Fee 
                                                        </span>
                                                        <p className='Market_text_p'> {amount2?formatter(Math.abs(amount-amount2)):"0.0"} {Tovalue2 ? Tovalue2.text:''}</p>
                                                    </li>
                                                    <li>
                                                        <span className='Market_text_p'>Minimum Received </span>
                                                        <p className='Market_text_p'> {amount2?formatter(Math.abs(amount2)):"0.0"} {Tovalue2 ? Tovalue2.text:''}</p>
                                                    </li>
                                                    <li>
                                                        <span className='Market_text_p'>Route </span>
                                                    </li>
                                                </ul>
                                                <div className='after_fee_bottom_btn'>
                                                    <p><img src={Tovalue.imglogo} alt="logo" /> {Tovalue.text}</p>
                                                    <img src={mer_dai_bottem_arrow} alt="logo" />
                                                    {token2 === null ? <p> Choose Token</p> : <p><img src={Tovalue2.imglogo} alt="" />{Tovalue2.text}</p>}
                                                </div>
                                            </>
                                        )} */}

                                    </div>
                                </div>
                                <div>
                                    {/* {notregistered ? (<> */}
                                        {/* <WebBotton WebBotton="Register" link="#0" click={() => registercoin()} /> */}
                                        {/* <ButtonLoad loading={loader} onClick={()=>registercoin()} >Register</ButtonLoad> */}
                                    {/* </>):(<> */}
                                        {/* <WebBotton WebBotton="Swap" link="#0"  click={() => Swap()} /> */}

{/* { Tovalue2 ? (<> */}
    {/* <ButtonLoad loading={loader} onClick={()=>Swap()} >Swap</ButtonLoad> */}

{/* </>):(<> */}
<br/>
<div> <WebOffBotton WebOffBotton="Add Liquidity" link="#0"   /></div>
   

{/* </>)} */}


    

                                    {/* </>)} */}
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='Main_Pool_block'>
                        <h2>Staking Pool</h2>
                        {/* {
                            MainPoolBoxData.map((item, index) => {
                                return (
                                    <div key={index}>
                                        <MainPoolBox Item={item} />
                                    </div>
                                )
                            })
                        } */}
                          <MainPoolBox Item={MainPoolBoxData[0]} />
                          {/* <MainPoolBox11 Item ={MainPoolBoxData[1]}/> */}
                          {/* <MainPoolBox1 Item={MainPoolBoxData[1]} />
                          <MainPoolBox2 Item={MainPoolBoxData[2]} /> */}
                    </div>
                </div>
            </div>
            <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className='modal_Box_main'>
          <Box className='modal_Box responsive_pop'>
            <div className='ConnectPop_main'>
              <div className='swap_tokens_pop_main'>
                <div className='ConnectPop_Close_btn'>
                  <a href="#0" onClick={handleClose}>
                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 0.5C8.02219 0.5 6.08879 1.08649 4.4443 2.1853C2.79981 3.28412 1.51809 4.8459 0.761209 6.67317C0.00433284 8.50043 -0.193701 10.5111 0.192152 12.4509C0.578004 14.3907 1.53041 16.1725 2.92894 17.5711C4.32746 18.9696 6.10929 19.922 8.0491 20.3079C9.98891 20.6937 11.9996 20.4957 13.8268 19.7388C15.6541 18.9819 17.2159 17.7002 18.3147 16.0557C19.4135 14.4112 20 12.4778 20 10.5C20 9.18678 19.7413 7.88642 19.2388 6.67317C18.7363 5.45991 17.9997 4.35752 17.0711 3.42893C16.1425 2.50035 15.0401 1.76375 13.8268 1.2612C12.6136 0.758658 11.3132 0.5 10 0.5V0.5ZM10 18.5C8.41775 18.5 6.87104 18.0308 5.55544 17.1518C4.23985 16.2727 3.21447 15.0233 2.60897 13.5615C2.00347 12.0997 1.84504 10.4911 2.15372 8.93928C2.4624 7.38743 3.22433 5.96197 4.34315 4.84315C5.46197 3.72433 6.88743 2.9624 8.43928 2.65372C9.99113 2.34504 11.5997 2.50346 13.0615 3.10896C14.5233 3.71447 15.7727 4.73984 16.6518 6.05544C17.5308 7.37103 18 8.91775 18 10.5C18 12.6217 17.1572 14.6566 15.6569 16.1569C14.1566 17.6571 12.1217 18.5 10 18.5V18.5Z" fill="#29ABE2" />
                      <path d="M12.7099 7.78994C12.617 7.69621 12.5064 7.62182 12.3845 7.57105C12.2627 7.52028 12.132 7.49414 11.9999 7.49414C11.8679 7.49414 11.7372 7.52028 11.6154 7.57105C11.4935 7.62182 11.3829 7.69621 11.2899 7.78994L9.99994 9.08994L8.70994 7.78994C8.52164 7.60164 8.26624 7.49585 7.99994 7.49585C7.73364 7.49585 7.47824 7.60164 7.28994 7.78994C7.10164 7.97824 6.99585 8.23364 6.99585 8.49994C6.99585 8.76624 7.10164 9.02164 7.28994 9.20994L8.58994 10.4999L7.28994 11.7899C7.19621 11.8829 7.12182 11.9935 7.07105 12.1154C7.02028 12.2372 6.99414 12.3679 6.99414 12.4999C6.99414 12.632 7.02028 12.7627 7.07105 12.8845C7.12182 13.0064 7.19621 13.117 7.28994 13.2099C7.3829 13.3037 7.4935 13.3781 7.61536 13.4288C7.73722 13.4796 7.86793 13.5057 7.99994 13.5057C8.13195 13.5057 8.26266 13.4796 8.38452 13.4288C8.50638 13.3781 8.61698 13.3037 8.70994 13.2099L9.99994 11.9099L11.2899 13.2099C11.3829 13.3037 11.4935 13.3781 11.6154 13.4288C11.7372 13.4796 11.8679 13.5057 11.9999 13.5057C12.132 13.5057 12.2627 13.4796 12.3845 13.4288C12.5064 13.3781 12.617 13.3037 12.7099 13.2099C12.8037 13.117 12.8781 13.0064 12.9288 12.8845C12.9796 12.7627 13.0057 12.632 13.0057 12.4999C13.0057 12.3679 12.9796 12.2372 12.9288 12.1154C12.8781 11.9935 12.8037 11.8829 12.7099 11.7899L11.4099 10.4999L12.7099 9.20994C12.8037 9.11698 12.8781 9.00638 12.9288 8.88452C12.9796 8.76266 13.0057 8.63195 13.0057 8.49994C13.0057 8.36793 12.9796 8.23722 12.9288 8.11536C12.8781 7.9935 12.8037 7.8829 12.7099 7.78994V7.78994Z" fill="#29ABE2" />
                    </svg>
                  </a>
                </div>
                <div className='swap_tokens_list'>
                  <h4> Trade ME</h4>
                  <div className='Confirm_Stack_main'>
                    <div className='Confirm_Stack_P_row'>
                      {/* <p className='Market_text_p'>Your LP balance:  {lpbalance?parseFloat(Math.abs(lpbalance/100000000)).toFixed(4):"0.0"} USDCLP</p> */}
                      {/* <span className='Market_text_p'>Stakable: {usdcbalance?parseFloat(Math.abs(usdcbalance/100000000)).toFixed(4):"0.0"} USDC</span> */}
                    </div>
                    <div className='Confirm_Stack_box'>
                    <img src={pangolin} width="30" height={"30"}alt="mer_dai_drop_item_logo" />Pangolin
                      <div  className='hero_btn'>
                        <a href="https://app.pangolin.exchange/#/pool/standard" target="_blank" rel="noreferrer"
                        // onClick={()=>maxval()}
                        >Trade</a>
                      </div>
                     </div>
                    {/* <div className='Confirm_Stack_box'>
                    <img src={aux} width="30" height={"30"}alt="mer_dai_drop_item_logo" /> Liquidswap 
                    <Badge> UPCOMINGS </Badge>                         */}
                      {/* <div className="max_btn"> */}
                       
                        {/* // onClick={()=>maxval()} */}
                        {/* <WebOffBotton WebOffBotton="Trade" link="#0"  /> */}
                      {/* <li>  <Badge> UPCOMINGS </Badge> </li>
                      </div> */}
                     {/* </div> */}


{/* <br></br> */}
{/* <ul className='Confirm_Stack_lists'>
<li>
    <div className="max_btn">
                        <a href="#0" 
                        >Animeswap </a>
                        
                      </div>
                      <img src={animeswap} width="40" height={"40"} alt="mer_dai_bottem_arrow" />
                      </li></ul> */}
                  {/* <ul className='Confirm_Stack_lists'>
                      <li>
                        <p className='Market_text_p'>Your LP balance: </p> */}
                        {/* <span className='Market_text_p'> {lpbalance?parseFloat(Math.abs(lpbalance/100000000)).toFixed(4):"0.0"} USDCLP</span> */}
                      {/* </li>
                      <li>
                        <p className='Market_text_p'>Token Stake</p>
                        <span className='Market_text_p'>0.00 Mercury</span>
                      </li>
                    </ul> */}
                     {/*<div className='Confirm_Swap_pop_btn'>
                      <div onClick={handleClose}>
                        <WebOffBotton WebOffBotton="Cancel" link="#0" />
                      </div>
                      <div className='approve_button hero_btn'>
                        {/* <a href="#0" onClick={()=>setfunction()} >{clickbutton}</a> */}
                      {/* </div>
                    </div>  */}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </Modal>
        </>
    )
}

export default PoolPage;